import MerchantProfilesService from "@/api/services/merchantProfiles";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    roles: () => () => {
      return [
        "seller",
        "manager",
        "claims_manager",
        "customer_support_manager",
        "accounting_manager",
        "responsible",
        "regional_manager",
        "organization_admin",
        "store_admin",
      ];
    },
    signedUpStatuses: () => () => {
      return [
        { label: "Oui", value: true },
        { label: "Non", value: false },
      ];
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex(
      { commit },
      { page = 1, keywords = null, organizationIds = [], storeIds = [], roles = [], signedUp = null } = {},
    ) {
      const response = await MerchantProfilesService.fetchIndex({
        page,
        keywords,
        organizationIds,
        storeIds,
        roles,
        signedUp,
      });
      if (!response?.success) return response;

      const { data } = response;
      commit("setIndex", toCamelCase(data));
    },
    async fetch(_, { id, ...params }) {
      const response = await MerchantProfilesService.fetch(id, params);
      if (!response?.success) return null;

      return toCamelCase(response.data);
    },
    async delete(_, id) {
      const response = await MerchantProfilesService.delete(id);
      return response?.success;
    },

    async update(_, { id, params }) {
      const response = await MerchantProfilesService.update(id, params);
      if (!response?.success) return null;

      return toCamelCase(response.data);
    },

    async create(_, params) {
      const { storeId, organizationId, ...merchantProfileData } = params;
      const response = await MerchantProfilesService.create(merchantProfileData, storeId, organizationId);

      if (!response?.success) return null;

      return toCamelCase(response.data);
    },

    async sendBulkInvitation(_, merchantProfileIds) {
      const response = await MerchantProfilesService.sendBulkInvitation(merchantProfileIds);
      return response?.success;
    },
  },
};
